// extracted by mini-css-extract-plugin
export default {"lntTabs":"styles_lnt-tabs__R+Bf4"};